var map = {
	"./TFT/TX_index.vue": [
		387,
		10
	],
	"./TFT/YK_index.vue": [
		388,
		9
	],
	"./TFT/detail.vue": [
		389,
		15
	],
	"./TFT/index.vue": [
		390,
		7
	],
	"./flypig/fly_pig_detail.vue": [
		391,
		19
	],
	"./flypig/fly_pig_order.vue": [
		392,
		21
	],
	"./flypig/fly_pig_validatel.vue": [
		393,
		18
	],
	"./home/activity0617.vue": [
		394,
		25
	],
	"./home/activity0618.vue": [
		395,
		24
	],
	"./home/category.vue": [
		396,
		14
	],
	"./home/index.vue": [
		397,
		8
	],
	"./home/search.vue": [
		398,
		12
	],
	"./member/customer.vue": [
		399,
		11
	],
	"./member/user.vue": [
		400,
		6
	],
	"./order/aliMiddle.vue": [
		401,
		16
	],
	"./order/cashier.vue": [
		402,
		3
	],
	"./order/order_components.vue": [
		386,
		1
	],
	"./order/order_detail.vue": [
		403,
		2
	],
	"./order/order_list.vue": [
		404,
		0
	],
	"./order/redirect.vue": [
		405,
		26
	],
	"./order/result.vue": [
		406,
		13
	],
	"./page/401.vue": [
		407,
		23
	],
	"./page/404.vue": [
		408,
		17
	],
	"./page/login.vue": [
		409,
		5
	],
	"./page/logout.vue": [
		410,
		22
	],
	"./page/nopermission.vue": [
		411,
		20
	],
	"./product/detail.vue": [
		412,
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 224;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components lazy ^\.\/.*\.vue$
// module id = 224
// module chunks = 28